import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { HomePage } from './pages/HomePage';
// Lazy load secondary pages for better initial load performance
const FlyerPage = lazy(() => import('./pages/FlyerPage').then(m => ({
  default: m.FlyerPage
})));
const FlyerA6Page = lazy(() => import('./pages/FlyerA6Page').then(m => ({
  default: m.FlyerA6Page
})));
const BlogPage = lazy(() => import('./pages/BlogPage').then(m => ({
  default: m.BlogPage
})));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage').then(m => ({
  default: m.BlogPostPage
})));
export function App() {
  return <HelmetProvider data-id="element-0">
      <Router data-id="element-1">
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center" data-id="element-3">
              <div className="text-gray-500" data-id="element-4">Loading...</div>
            </div>} data-id="element-2">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/flyer" element={<FlyerPage data-id="element-9" />} data-id="element-8" />
            <Route path="/flyer-a6" element={<FlyerA6Page data-id="element-11" />} data-id="element-10" />
            <Route path="/blog" element={<BlogPage data-id="element-13" />} data-id="element-12" />
            <Route path="/blog/:slug" element={<BlogPostPage data-id="element-15" />} data-id="element-14" />
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>;
}